module.exports = __webpack_public_path__ + "static/img/15.d94952fd.jpg";